import { Box, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import { AverageStrideAnglesCardData } from './AverageStrideAnglesCardData';
import { StrideAnglesPanel } from './StrideAnglesPanel';

interface AverageStrideAnglesCardProps {
  data?: AverageStrideAnglesCardData;
  onClick: (arg: string) => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
}));

const AverageStrideAnglesCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
  padding: '0px 0px 0px 16px !important',
}));

const PanelDisplayBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const AverageStrideAnglesCard: React.FC<AverageStrideAnglesCardProps> = ({
  data,
  onClick,
}: AverageStrideAnglesCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      large
      title={t('averageStrideAngles.title')}
      iconName="AverageStrideAngles"
      onClick={() => onClick('_10MWT')}
      enabled={!isEmpty(data)}
    >
      <AverageStrideAnglesCardMedia>
        <CardDetailTypography>
          {t('averageStrideAngles.toeOff')}
        </CardDetailTypography>
        <CardDetailTypography>
          {t('averageStrideAngles.heelStrike')}
        </CardDetailTypography>
        <PanelDisplayBox>
          <StrideAnglesPanel
            title={data ? data.left.title : t('averageStrideAngles.leftFoot')}
            base={data ? data.left.length + data.unit : 'N/A'}
            toeOff={data ? data.left.toe + '°' : '0°'}
            heelStrike={data ? data.left.heel + '°' : '0°'}
          />
          <StrideAnglesPanel
            title={data ? data.right.title : t('averageStrideAngles.rightFoot')}
            base={data ? data.right.length + data.unit : 'N/A'}
            toeOff={data ? data.right.toe + '°' : '0°'}
            heelStrike={data ? data.right.heel + '°' : '0°'}
          />
        </PanelDisplayBox>
      </AverageStrideAnglesCardMedia>
    </ParameterCard>
  );
};

export default AverageStrideAnglesCard;
